import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { AppInitService } from '../services/app-init.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PrivilegeGuard implements CanActivateChild {
  private allowedRouteMap = {};
  private allowedRegex = null;
  constructor(
    private router: Router,
    private http: HttpClient,
    private appInitService: AppInitService
  ) {}
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    if (!this.appInitService.appConfig?.privGuard) {
      return true;
    }
    if (state.url.includes('login')) {
      return true;
    }
    if (state.url.includes('unauthorized')) {
      return true;
    }

    return of(this.allowedRouteMap).pipe(
      switchMap((allowedRoutes: any) => {
        if (allowedRoutes && Object?.keys(allowedRoutes)?.length > 0) {
          return this.checkPrivilege(state);
        } else {
          return this.http.get('/access-control/priv-urls').pipe(
            map((res: any) => res?.data),
            switchMap((routes) => {
              if (routes?.dynamic_url) {
                this.allowedRegex = routes?.dynamic_url.join('|');
              }
              this.allowedRouteMap = routes?.static_url?.reduce(
                (map, routeUrl) => {
                  map[routeUrl] = true;
                  return map;
                },
                {}
              );
              this.allowedRouteMap[
                this.appInitService.appConfig.afterLoginLandingUrl
              ] = true;
              return this.checkPrivilege(state);
            }),
            catchError(() => {
              this.router.navigateByUrl(
                this.appInitService.appConfig.authenticationLogoutUrl
              );
              return throwError('ERROR');
            })
          );
        }
      })
    );
  }
  private checkPrivilege(
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> {
    let access = false;
    let subUrl = state.url;

    if (state?.url?.[0] == '/') {
      subUrl = state.url.substring(1, state.url?.length);
    }

    if (this.allowedRouteMap[state?.url] || this.allowedRouteMap[subUrl]) {
      access = true;
    } else if (this.allowedRegex && state.url.match(this.allowedRegex)) {
      access = true;
    }
    if (!access) {
      return this.router.navigateByUrl(
        this.appInitService.appConfig.unauthorizedUrl
      );
    }

    return of(access);
  }

  public resetPrivRoutes(): void {
    this.allowedRouteMap = {};
    this.allowedRegex = null;
  }
}
